import { render, staticRenderFns } from "./RuleGroupDetails.vue?vue&type=template&id=2dcce080"
import script from "./RuleGroupDetails.vue?vue&type=script&lang=js"
export * from "./RuleGroupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports